import * as React from 'react';
import { ModalContainer } from '@moovly/ui';
import { t } from '@moovly/i18n';

export const useConfirmationModal = ({ confirmButtonText }: { confirmButtonText?: string } = {}) => {
  const [open, setOpen] = React.useState<null | { title: string; description: string }>(null);
  const confirm = React.useRef<(() => void) | null>(null);

  const ConfirmationModal = () => {
    const handleConfirm = React.useCallback(() => {
      if (confirm.current) confirm.current();
      confirm.current = null;
      setOpen(null);
    }, []);
    const handleClose = React.useCallback(() => {
      confirm.current = null;
      setOpen(null);
    }, []);
    return (
      <ModalContainer
        setOpen={() => setOpen(null)}
        title={open && open.title}
        description={open && open.description}
        isOpen={!!open}
        onConfirm={handleConfirm}
        onClose={handleClose}
        closeButtonText={t('actions.cancel')}
        confirmButtonText={confirmButtonText}
      />
    );
  };
  return {
    openConfirmationModal: ({ title, description }: { title: string; description: string }, cb: () => void) => {
      confirm.current = cb;
      setOpen({ title, description });
    },
    ConfirmationModal,
  };
};

export default useConfirmationModal;
